//TODO: MJ I wanted to implement this barrel type file for reducing imports length
import useData from "./useData";
export default useData;